exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spinner > div[data-v-7e7cff18] {\n    color:#d8322d !important\n}\n", ""]);

// exports
